// extracted by mini-css-extract-plugin
module.exports = {"fileInput":"fileInput__1M6xi","button":"button__2KEls","spinner":"spinner__31jvh"};